import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
} from '@mui/material';
import { currency } from '../../utils/utils';
import moment from 'moment/moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './styles.module.scss';

type ItemVentaProps = {
    data: any
}

const ESTADOS: Record<string, { label: string; className: string }> = {
  waiting_payment: { label: 'Esperando pago', className: styles.estadoPendiente },
  pending: { label: 'Pendiente', className: styles.estadoPendiente },
  in_process: { label: 'En proceso', className: styles.estadoPendiente },
  approved: { label: 'Pagado', className: styles.estadoAprobado },
  rejected: { label: 'Rechazado', className: styles.estadoRechazado },
  cancelled: { label: 'Cancelado', className: styles.estadoRechazado },
  refunded: { label: 'Reembolsado', className: styles.estadoRechazado },
  charged_back: { label: 'Contracargo', className: styles.estadoRechazado },
};

const getEstadoInfo = (estado: string) => ESTADOS[estado] || { label: estado, className: styles.estadoPendiente };

// Hoy no hay un campo dedicado para distinguir ventas mayoristas de minoristas:
// checkout-mayorista guarda en la misma tabla "ventas" y solo se distingue por este texto libre.
const isMayorista = (tipoDeEnvio: string) => (tipoDeEnvio || '').toLowerCase().startsWith('compra mayorista');

const ItemVenta = (props: ItemVentaProps) => {

  const venta = props.data;
  const attrs = venta.attributes;
  const estadoInfo = getEstadoInfo(attrs?.estado);
  const total = Number(attrs?.total || 0) + Number(attrs?.precioEnvio || 0);

  return (
    <div className={styles.item}>
      <div className={styles.header}>
        <div className={styles.headerInfo}>
          <div className={styles.pedidoLinea}>
            <span className={styles.pedidoNumero}>Pedido #{venta.id}</span>
            {isMayorista(attrs?.tipoDeEnvio) && <span className={styles.badgeMayorista}>Mayorista</span>}
          </div>
          <span className={styles.fecha}>{moment(attrs?.createdAt).format("DD/MM/YYYY")}</span>
        </div>
        <div className={styles.headerTotales}>
          <Chip label={estadoInfo.label} size="small" className={`${styles.chip} ${estadoInfo.className}`} />
          <span className={styles.total}>${currency(total)}</span>
        </div>
      </div>

      <Accordion
        disableGutters
        className={styles.accordion}
        sx={{
          boxShadow: 'none',
          '&::before': { display: 'none' },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`venta-${venta.id}-detalle`}
          id={`venta-${venta.id}-header`}
          className={styles.accordionSummary}
        >
          Ver detalle del pedido
        </AccordionSummary>
        <AccordionDetails className={styles.accordionDetails}>
          <div className={styles.resumenRow}>
            <span>Productos</span>
            <span>${currency(attrs?.total)}</span>
          </div>
          <div className={styles.resumenRow}>
            <span>Envío</span>
            <span>${currency(attrs?.precioEnvio)}</span>
          </div>

          <div className={styles.productos}>
            {attrs?.productos?.map((item: any, index: number) => (
              <div className={styles.productoRow} key={index}>
                <img
                  src={item.foto}
                  alt={item.producto}
                  className={styles.productoImagen}
                />
                <span className={styles.productoNombre}>{item.producto}</span>
                <span className={styles.productoCantidad}>x{item.cantidad}</span>
              </div>
            ))}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ItemVenta;
